module.exports = __webpack_public_path__ + "img/pin.8f1ef86d.svg";